module.exports = __webpack_public_path__ + "static/img/dn4.72deab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn4.png
// module id = KXes
// module chunks = 0